import { defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import { CampaignsResponseSchema } from '../shared/schemas.js';

export const campaigns = defaultClient.query({
  url: 'authentication/v1/campaigns/' as const,
  method: 'GET',
  querySchema: z.object({
    search: z.string().optional(),
  }),
  responseSchema: CampaignsResponseSchema,
  processResponse(data) {
    return data.map((item) => ({
      ...item,
      id: String(item.id),
    }));
  },
});
